export const ENTER_OTP = 'Enter OTP';
export const ENTER_OTP_LONG_TEXT_START = `Enter the 6-digit code sent to your registered `;
// export const ENTER_OTP_LONG_TEXT_END = ` for transaction/nomination confirmation.`;
export const VERIFY_OTP = 'OTP Verification';
export const SUBMIT = 'Verify OTP';
export const CLOSE = 'Close';
export const ENTER_OTP_LONG_TEXT_USER_DETAILS = (mobileNumber, emailId) => `mobile no. ${mobileNumber} & email ID ${emailId.toLowerCase()}`